import { Collection } from 'modules/core/lib/mobx-rest'

import Form from 'modules/enps/store/models/Form'

class Forms extends Collection<Form> {
  get cacheKey(): string {
    return 'enpsForms'
  }

  model() {
    return Form
  }
}

export default new Forms()
